// @flow weak
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

export const cloneComponentChildren = (
  children,
  extraProps,
  arrayContainer = 'div'
) => {
  if (!children) {
    return null;
  }

  if (_.isFunction(children)) {
    return children(extraProps);
  }

  if (!_.isArray(children)) {
    return React.cloneElement(children, extraProps || {});
  }

  const clones = React.Children.map(children, child => {
    return React.cloneElement(child, extraProps);
  });

  if (_.isFunction(arrayContainer)) {
    return arrayContainer(clones);
  }

  return React.createElement(arrayContainer, {}, clones);
};

export const setRef = (Component, key) => nodeOrComponent => {
  // The ref might be a real DOM node _or_ a representation of a component
  _.set(Component, ['dangerousRefs', key], nodeOrComponent);
};

export const getRef = (Component, key) =>
  // Regardless of whether the ref is a real DOM node or a component,
  // always return the representative DOM node.
  ReactDOM.findDOMNode(_.get(Component, ['dangerousRefs', key]));

export const preventDefaultEvent = (event: SyntheticEvent<HTMLElement>) => {
  event.preventDefault();
};
